/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiTemplateCustomization } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of CustomizationsController.
 */
export class CustomizationsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /print_options/{printOptionId}/customizations
     */
    public getTemplateCustomization(printOptionId: string): Promise<Result<ApiTemplateCustomization[]>> {
        return this.http.get<Result<ApiTemplateCustomization[]>>(`/print_options/${printOptionId}/customizations`);
    }

    /**
     * Calls PATCH /print_options/{printOptionId}/customizations
     */
    public saveTemplateCustomization(printOptionId: string, dtos: ApiTemplateCustomization[]): Promise<Result<ApiTemplateCustomization[]>> {
        return this.http.patch<Result<ApiTemplateCustomization[]>, ApiTemplateCustomization[]>(`/print_options/${printOptionId}/customizations`, dtos);
    }

    /**
     * Calls PATCH /print_options/{printOptionId}/customizations:update
     */
    public updateTemplateCustomization(printOptionId: string, dtos: ApiTemplateCustomization): Promise<Result<ApiTemplateCustomization>> {
        return this.http.patch<Result<ApiTemplateCustomization>, ApiTemplateCustomization>(`/print_options/${printOptionId}/customizations:update`, dtos);
    }

    /**
     * Calls POST /print_options/customizations:update-typst-values
     */
    public updateTypstCustomizations(): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>('/print_options/customizations:update-typst-values', undefined);
    }
}
